<template>
  <div
    v-if="loading.isLoading"
    class="loading-overlay !flex !flex-col !items-center !justify-center"
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <img
      v-if="isClient && siteSettingsStore.logo"
      :src="`${baseUrl}${siteSettingsStore.logo}`"
      alt=""
      aria-hidden="true"
      loading="eager"
      decoding="async"
      class="w-[180px] xl:w-[200px] mt-4"
    />
    <div v-else class="loader"></div>
  </div>
</template>
<script setup>
import { useLoadingStore, useSiteSettingsStore } from "@/store/index";
const loading = useLoadingStore();
const siteSettingsStore = useSiteSettingsStore();
const isClient = ref(false);

const runtimeConfig = useRuntimeConfig();
const baseUrl = runtimeConfig.public.baseUrl;

onMounted(() => {
  isClient.value = true;
});
</script>
<style>
/* HTML: <div class="loader"></div> */
.loader {
  width: 40px;
  aspect-ratio: 1;
  --c: linear-gradient(#444444 0 0);
  --r1: radial-gradient(farthest-side at bottom, #444444 93%, #0000);
  --r2: radial-gradient(farthest-side at top, #444444 93%, #0000);
  background: var(--c), var(--r1), var(--r2), var(--c), var(--r1), var(--r2),
    var(--c), var(--r1), var(--r2);
  background-repeat: no-repeat;
  animation: l2 1s infinite alternate;
}
@keyframes l2 {
  0%,
  25% {
    background-size: 8px 0, 8px 4px, 8px 4px, 8px 0, 8px 4px, 8px 4px, 8px 0,
      8px 4px, 8px 4px;
    background-position: 0 50%, 0 calc(50% - 2px), 0 calc(50% + 2px), 50% 50%,
      50% calc(50% - 2px), 50% calc(50% + 2px), 100% 50%, 100% calc(50% - 2px),
      100% calc(50% + 2px);
  }
  50% {
    background-size: 8px 100%, 8px 4px, 8px 4px, 8px 0, 8px 4px, 8px 4px, 8px 0,
      8px 4px, 8px 4px;
    background-position: 0 50%, 0 calc(0% - 2px), 0 calc(100% + 2px), 50% 50%,
      50% calc(50% - 2px), 50% calc(50% + 2px), 100% 50%, 100% calc(50% - 2px),
      100% calc(50% + 2px);
  }
  75% {
    background-size: 8px 100%, 8px 4px, 8px 4px, 8px 100%, 8px 4px, 8px 4px,
      8px 0, 8px 4px, 8px 4px;
    background-position: 0 50%, 0 calc(0% - 2px), 0 calc(100% + 2px), 50% 50%,
      50% calc(0% - 2px), 50% calc(100% + 2px), 100% 50%, 100% calc(50% - 2px),
      100% calc(50% + 2px);
  }
  95%,
  100% {
    background-size: 8px 100%, 8px 4px, 8px 4px, 8px 100%, 8px 4px, 8px 4px,
      8px 100%, 8px 4px, 8px 4px;
    background-position: 0 50%, 0 calc(0% - 2px), 0 calc(100% + 2px), 50% 50%,
      50% calc(0% - 2px), 50% calc(100% + 2px), 100% 50%, 100% calc(0% - 2px),
      100% calc(100% + 2px);
  }
}
</style>
